export const highlightText = (
  completeText: string | null,
  searchedText: string,
  className: string
): any => {
  if (completeText === null) {
    return completeText;
  }
  const searched = searchedText.toUpperCase();
  const complete = completeText.toLocaleUpperCase();
  return complete.replace(
    searched,
    `<span class=${className}>` + searched + '</span>'
  );
};
